<template>
    <div class="chat-contact" @click="$emit('click', contact)">
        <div class="chat-contact__bg" :style="{opacity}"></div>
        <div class="chat-contact__img">
            <img :src="contact.image" :alt="contact.client_info">
            <div class="chat-contact__vip" v-if="contact.client_vip">
                <svg aria-hidden="true" width="18" height="18">
                    <use href="#icon-crown-2"></use>
                </svg>
            </div>
        </div>
        <div class="chat-contact__cont" >
            <div class="chat-contact__cont-top">
                <div class="chat-contact__text">
                    {{ contact.client_info }}
                </div>
                <div class="chat-contact__date">{{ contact.date_create }}</div>
            </div>
            
            <div class="chat-contact__cont-bottom">
                <div class="chat-contact__message">
                    {{ contact.message }}
                </div>
                <div class="chat-contact__counter" v-if="contact.count_unread">
                    <template v-if="contact.count_unread < 100">
                        {{ contact.count_unread }}
                    </template>
                    <template v-else>
                        99+
                    </template>
                </div>
            </div>
            <p v-if="contact.is_bot_chat && !contact.need_operator" class="chat-contact__bot">
                <svg aria-hidden="true" width="22" height="22">
                    <use href="#icon-Ai"></use>
                </svg>
                Чат взят в работу ИИ-ассистентом
            </p>
            <p v-if="contact.need_operator" class="chat-contact__need_operator">
                <svg aria-hidden="true" width="22" height="22">
                    <use href="#icon-warning-cercle"></use>
                </svg>
                {{ contact.need_operator_sender || 'Водитель запросил оператора' }} 
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contact:''
    },

    data () {
        return {
            timer:null,
            currentTime: null,
            opacity: null
        }
    },
    beforeDestroy() {
        clearInterval(this.time)
    },
    mounted() {  
        this.timerStart()
    },
    methods: {
        timerStart() {
            this.time = setInterval(() => {
                this.opacity = Math.min((Date.now() - this.contact.time) / 120000, 1)
            }, 100)
        }
    }
}
</script>